import { useFilterLevelContext } from "./filter-level.context";

export function FilterLevel() {
  const { dateFilterElement, clearFiltersElement } =
    useFilterLevelContext();

  return (
    <div>
      <h2>Filters</h2>
      <p className="mb-4">
        Select the following filters you want to apply to the current table.
      </p>

      {dateFilterElement}
      {clearFiltersElement}
    </div>
  );
}